// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column>.form-select[data-v-6b88a2d2]{margin:1.3rem 0}.form-input[data-v-6b88a2d2]{margin-top:1.5rem}.buttons .button.is-text[data-v-6b88a2d2]{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
